/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedsendnewsletterenabled3Inputs */

const en__field_inheritedsendnewsletterenabled3 = /** @type {(inputs: _Field_Inheritedsendnewsletterenabled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`send newsletter (derived)`)
};

const de__field_inheritedsendnewsletterenabled3 = /** @type {(inputs: _Field_Inheritedsendnewsletterenabled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newsletter versenden (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "send newsletter (derived)" |
*
* @param {_Field_Inheritedsendnewsletterenabled3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedsendnewsletterenabled3 = /** @type {((inputs?: _Field_Inheritedsendnewsletterenabled3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedsendnewsletterenabled3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedsendnewsletterenabled3(inputs)
	return de__field_inheritedsendnewsletterenabled3(inputs)
});
export { _field_inheritedsendnewsletterenabled3 as "_field_inheritedSendNewsletterEnabled" }